import _ from 'lodash';
import api from '../../api';
import * as types from '../mutation-types';

const state = {
  // 代購請求數據
  proxyRequest: [],
  // 分頁數據
  proxyPagination: [],
};

const getters = {};

const actions = {
  fetchProxyRequest({ commit }, params = {}) {
    api.proxy.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_PROXY_REQUEST, response);
    });
  },
  createProxyRequest({ commit }, params) {
    return api.proxy.post(params).then(({ data: response }) => {
      commit(types.UPDATE_PROXY_REQUEST, response.data);
    });
  },
  updateProxyRequest({ commit }, params) {
    return api.proxy.post(params).then(({ data: response }) => {
      commit(types.CREATE_PROXY_REQUEST, { id: params.id, data: response.data });
    });
  },
  cancelProxyRequest({ commit }, id) {
    return api.proxy.delete(id).then(() => {
      commit(types.DELETE_PROXY_REQUEST, id);
    });
  },
};
/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_PROXY_REQUEST](s, data) {
    s.proxyRequest = data.data;
    s.proxyPagination = data.meta.pagination;
  },
  [types.CREATE_PROXY_REQUEST](s, data) {
    s.proxyRequest = [...s.proxyRequest, data];
  },
  [types.UPDATE_PROXY_REQUEST](s, { id, data }) {
    const index = _.findIndex(s.proxyRequest, { id });
    if (~index) {
      const newRequests = [...s.proxyRequest];
      newRequests[index] = data;
      s.proxyRequest = newRequests;
    }
  },
  [types.DELETE_PROXY_REQUEST](s, id) {
    s.proxyRequest = _.reject(s.proxyRequest, item => item.id === id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
